// "Your 15-minute demo has ended" (spec/24 §4.3): what the demo console and the landing page's side-by-side view
// show in place of the venue once the window is over — thanks, when another demo can start, and the way back.

import { Button } from '@clavian/ui-web';
import type { ReactNode } from 'react';
import { useTranslation } from '@clavian/i18n/react';

/** When, in the visitor's own clock: "8 Oct 2026, 10:00". */
export function formatWhen(at: number): string {
  return new Intl.DateTimeFormat(undefined, { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(at));
}

export function DemoEnded({
  nextStartAt,
  canStartAgain,
  onStartAgain,
}: {
  readonly nextStartAt: number;
  readonly canStartAgain: boolean;
  readonly onStartAgain: () => void;
}): ReactNode {
  const { t } = useTranslation('demo');
  return (
    <main className="demo-page demo-ended" aria-labelledby="demo-ended-title">
      <h1 id="demo-ended-title">{t('ended.title')}</h1>
      <p>{t('ended.body')}</p>
      <p>{canStartAgain ? t('ended.nextNow') : t('ended.next', { when: formatWhen(nextStartAt) })}</p>
      <div className="demo-ended__actions">
        {canStartAgain ? <Button onClick={onStartAgain}>{t('ended.startAgain')}</Button> : null}
        <a className="demo-ended__home" href="/">
          {t('ended.home')}
        </a>
      </div>
    </main>
  );
}
